'use client';

import { useState } from 'react';
import { BoxProps } from '@mui/material';
import { useTranslations } from 'next-intl';

import { Row } from '@dh/styles';
import { ProfilePicture } from '@dh/components';
import { Author, User } from '@dh/types';
import { useUser } from '@dh/hooks';

import { OutlinedButton } from '../../buttons';
import { DHTextField } from '../../inputs';

interface Props extends BoxProps {
    author: User | Author;
    replyTo?: string;
    initialValue?: string;
    onSubmitComment: (comment: string) => void;
}

export const CommentInput = ({
    author,
    replyTo,
    initialValue = '',
    onSubmitComment,
    ...boxProps
}: Props) => {
    const t_details = useTranslations('details');
    const { user } = useUser({ withProfilePicture: true });
    const [comment, setComment] = useState(initialValue);

    const onSubmit = () => {
        onSubmitComment(comment);
        setComment('');
    };

    return (
        <Row stretch gap={2} {...boxProps}>
            <ProfilePicture imageUrl={user ? user.profilePicture?.url : undefined} />
            <DHTextField
                sx={{ flex: 1 }}
                name='comment'
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder={
                    replyTo
                        ? t_details('reply_to_comment', { user: replyTo })
                        : t_details('ask_your_question')
                }
                maxLength={100}
            />
            <OutlinedButton
                disabled={comment.length === 0}
                onClick={onSubmit}
                label={t_details('submit')}
            />
        </Row>
    );
};
